import {
  block_fencing,
  grey_siding_and,
  metal_roof_and,
  orange_and_grey,
  orange_siding,
  red_and_grey,
  silver_metal,
  fencing_1,
  fencing_2,
  fencing_3,
  fencing_4,
  fencing_5,
  fencing_6,
  fencing_7,
  fencing_8,
  fencing_9,
  cladding_1,
  cladding_2,
  cladding_3,
  cladding_4,
  cladding_5,
  cladding_6,
  cladding_7,
  cladding_8,
  cladding_9,
  cladding_10,
  cladding_11,
  cladding_12,
  cladding_13,
  cladding_14,
  cladding_15,
  cladding_16,
  cladding_17,
  cladding_18,
  cladding_19,
  cladding_20,
  cladding_21,
  cladding_22,
  cladding_23,
  cladding_24,
  roofing_1,
  roofing_2,
  roofing_3,
  roofing_4,
  roofing_5,
  roofing_6,
  roofing_7,
  roofing_8,
  roofing_9,
  roofing_10,
  roofing_11,
  roofing_12,
  roofing_13,
  roofing_14,
  roofing_15,
  roofing_16,
  roofing_17,
  roofing_18,
} from "../utils/images"

const products = {
  "metal-roofing": {
    title: "Metal roofing",
    images: [
      { original: grey_siding_and },
      { original: metal_roof_and },
      { original: red_and_grey },
      { original: silver_metal },
      { original: roofing_1 },
      { original: roofing_2 },
      { original: roofing_3 },
      { original: roofing_4 },
      { original: roofing_5 },
      { original: roofing_6 },
      { original: roofing_7 },
      { original: roofing_8 },
      { original: roofing_9 },
      { original: roofing_10 },
      { original: roofing_11 },
      { original: roofing_12 },
      { original: roofing_13 },
      { original: roofing_14 },
      { original: roofing_15 },
      { original: roofing_16 },
      { original: roofing_17 },
      { original: roofing_18 },
    ],
    categories: [
      {
        name: "Exposed Fastener Roofing",
        products: [
          {
            name: "Tough Rib",
            link: "http://westmansteel.com/product/steel-profile-tough-rib/",
          },
          {
            name: "936",
            link: "http://westmansteel.com/product/steel-profile-936/",
          },
          {
            name: "Rainbow Rib",
            link: "http://westmansteel.com/product/steel-profile-rainbow-rib/",
          },
          {
            name: "AWR",
            link: "http://westmansteel.com/product/steel-profile-awr/",
          },
          {
            name: "Diamond Rib 36 - 26Ga.",
            link:
              "http://westmansteel.com/product/steel-profile-diamond-rib-36/",
          },
          {
            name: "Diamond Rib 30 - 26Ga.",
            link:
              "http://westmansteel.com/product/steel-profile-diamond-rib-30/",
          },
          {
            name: "Ultra Span",
            link: "http://westmansteel.com/product/steel-profile-ultra-span/",
          },
          {
            name: "Elite Rib",
            link: "http://westmansteel.com/product/steel-profile-elite-rib/",
          },
          {
            name: "7/8 Corrugated",
            link:
              "http://westmansteel.com/product/steel-profile-7-8-corrugated-32/",
          },
        ],
      },
      {
        name: "Hidden Fastener Roofing",
        products: [
          {
            name: 'WS279 1" reveal',
            link:
              "http://westmansteel.com/product/steel-profile-ws279-panel-1-reveal/",
          },
          {
            name: "WS200 | WS300",
            link: "http://westmansteel.com/product/steel-profile-ws200-ws300/",
          },
          {
            name: "1 1/2” Mechanical Lock",
            link:
              "http://westmansteel.com/product/steel-profile-1-1-2-mechanical-lock/",
          },
          {
            name: "2” Mechanical Lock",
            link:
              "http://westmansteel.com/product/steel-profile-2-mechanical-lock/",
          },
          {
            name: "1 1/2” Snap Seam",
            link:
              "http://westmansteel.com/product/steel-profile-1-1-2-snap-seam/",
          },
          {
            name: "12” Snap-Lok",
            link: "http://westmansteel.com/product/steel-profile-snap-lok-12/",
          },
          {
            name: "16” Snap-Lok",
            link: "http://westmansteel.com/product/steel-profile-snap-lok-16/",
          },
        ],
      },
      {
        name: "Steel Shingle Roofing",
        products: [
          {
            name: "ArrowLine Shake",
            link: "https://westmansteel.com/product/arrowline-shake/",
          },
          {
            name: "ArrowLine Slate",
            link: "http://westmansteel.com/product/arrowline-slate/",
          },
          {
            name: "Generation Shake HD",
            link: "http://westmansteel.com/product/generations-shake-hd/",
          },
          {
            name: "Infiniti Shake",
            link: "http://westmansteel.com/product/infiniti-shake/",
          },
          {
            name: "DECRA Shake XD",
            link: "http://westmansteel.com/product/decra-shake-xd/",
          },
          {
            name: "DECRA Shingle XD",
            link: "http://westmansteel.com/product/decra-shingle-xd/",
          },
        ],
      },
    ],
  },
  "interior-exterior-cladding": {
    title: "Interior and Exterior Cladding",
    images: [
      { original: orange_and_grey },
      { original: orange_siding },
      { original: grey_siding_and },
      { original: metal_roof_and },
      { original: red_and_grey },
      { original: cladding_1 },
      { original: cladding_2 },
      { original: cladding_3 },
      { original: cladding_4 },
      { original: cladding_5 },
      { original: cladding_6 },
      { original: cladding_7 },
      { original: cladding_8 },
      { original: cladding_9 },
      { original: cladding_10 },
      { original: cladding_11 },
      { original: cladding_12 },
      { original: cladding_13 },
      { original: cladding_14 },
      { original: cladding_15 },
      { original: cladding_16 },
      { original: cladding_17 },
      { original: cladding_18 },
      { original: cladding_19 },
      { original: cladding_20 },
      { original: cladding_21 },
      { original: cladding_22 },
      { original: cladding_23 },
      { original: cladding_24 },
    ],
    categories: [
      {
        name: "Exposed Fastener",
        products: [
          {
            name: "Tough Rib",
            link: "http://westmansteel.com/product/steel-profile-tough-rib/",
          },
          {
            name: "936",
            link: "http://westmansteel.com/product/steel-profile-936/",
          },
          {
            name: "Diamond Rib 36 - 29Ga.",
            link:
              "http://westmansteel.com/product/steel-profile-diamond-rib-36/",
          },
          {
            name: "Elite Rib - Reversable",
            link: "http://westmansteel.com/product/steel-profile-elite-rib/",
          },
          {
            name: "Ultra Span - Reversable",
            link: "http://westmansteel.com/product/steel-profile-ultra-span/",
          },
          {
            name: "1/2” Corrugated - 29Ga.",
            link:
              "http://westmansteel.com/product/steel-profile-1-2-corrugated/",
          },
          {
            name: "7/8 Corrugated - 30“ - 32“ -37“  26Ga.",
            link:
              "http://westmansteel.com/product/steel-profile-7-8-corrugated-37/",
          },
          {
            name: "AWR",
            link: "http://westmansteel.com/product/steel-profile-awr/",
          },
          {
            name: "Deluxe Mesa",
            link: "http://westmansteel.com/product/steel-profile-deluxe-mesa/",
          },
        ],
      },
      {
        name: "Hidden Fastener",
        products: [
          {
            name: "12” Snap-Lok",
            link: "http://westmansteel.com/product/steel-profile-snap-lok-12/",
          },
          {
            name: "16” Snap-Lok",
            link: "http://westmansteel.com/product/steel-profile-snap-lok-16/",
          },
          {
            name: "WS200 WS300",
            link: "http://westmansteel.com/product/steel-profile-ws200-ws300/",
          },
          {
            name: "WS279 - 1” Reveal",
            link:
              "http://westmansteel.com/product/steel-profile-ws279-panel-1-reveal/",
          },
        ],
      },
    ],
  },
  "fencing-flashing": {
    title: "Fencing and Flashing",
    images: [
      { original: grey_siding_and },
      { original: metal_roof_and },
      { original: red_and_grey },
      { original: block_fencing },
      { original: fencing_1 },
      { original: fencing_2 },
      { original: fencing_3 },
      { original: fencing_4 },
      { original: fencing_5 },
      { original: fencing_6 },
      { original: fencing_7 },
      { original: fencing_8 },
      { original: fencing_9 },
    ],
    categories: [
      {
        name: "All products",
        products: [
          {
            name: "7/8 Corrugated - 30”- 32”- 37” 26Ga.",
            link:
              "http://westmansteel.com/product/steel-profile-7-8-corrugated-37/",
          },
          {
            name: "AWR",
            link: "http://westmansteel.com/product/steel-profile-awr/",
          },
          {
            name: "Diamond Rib 36",
            link:
              "http://westmansteel.com/product/steel-profile-diamond-rib-36/",
          },
          {
            name: "Elite Rib",
            link: "http://westmansteel.com/product/steel-profile-elite-rib/",
          },
          {
            name: "Tough Rib",
            link: "http://westmansteel.com/product/steel-profile-tough-rib/",
          },
          {
            name: "936",
            link: "http://westmansteel.com/product/steel-profile-936/",
          },
          {
            name: "Rainbow Rib",
            link: "http://westmansteel.com/product/steel-profile-rainbow-rib/",
          },
        ],
      },
    ],
  },
}

export { products }
